import { render, staticRenderFns } from "./BDXUploader.vue?vue&type=template&id=52f19baf&scoped=true"
import script from "./BDXUploader.vue?vue&type=script&lang=js"
export * from "./BDXUploader.vue?vue&type=script&lang=js"
import style0 from "./BDXUploader.vue?vue&type=style&index=0&id=52f19baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f19baf",
  null
  
)

export default component.exports